import {BooleanKeys} from "framework/typescript-integration";
import React from "react";
import {observer} from "mobx-react";
import {CheckOutlined} from "@ant-design/icons";

export interface BooleanRendererProps<T extends object,  K extends BooleanKeys<T>>{
	model?: T
	field?: K
	value?: boolean
}

export const BooleanRenderer = observer(<T extends object, K extends BooleanKeys<T>>(props: BooleanRendererProps<T, K>) => {
	let {model, field} = props
	const value = props.value !== undefined ? props.value: !!model[field]

	return <>
		{value && <CheckOutlined />}
	</>
})
